import { $getNodeByKey, LexicalEditor, NodeKey } from 'lexical';

export async function scrollToNode(editor: LexicalEditor, key: NodeKey) {
  const element = editor.getElementByKey(key);
  if (!element) return;

  const editorRoot = editor.getRootElement();
  const scrollContainer =
    editorRoot?.closest('[style*="overflow"]') ??
    editorRoot?.parentElement ??
    document.documentElement;

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });

  if (scrollContainer) {
    await waitForScrollEnd(scrollContainer);
  }

  requestAnimationFrame(() => {
    editor.update(() => {
      $getNodeByKey(key)?.selectStart();
    });
  });
}

function waitForScrollEnd(element: Element): Promise<void> {
  return new Promise(resolve => {
    let timeoutId: number;

    function bumpTimeout() {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        element.removeEventListener('scroll', bumpTimeout);
        resolve();
      }, 100);
    }

    element.addEventListener('scroll', bumpTimeout);
    bumpTimeout();
  });
}
